import React from 'react';
import classNames from 'classnames';
import _ from 'underscore';

var PropTypes = require('prop-types');

class Tabs extends React.Component {
  static propTypes = {
    children: PropTypes.arrayOf(PropTypes.node),
    onChange: PropTypes.func,
  }

  static defaultProps = {
    onChange: () => {},
  }

  constructor(props, context) {
    super(props, context);

    this.state = {
      activeChild: this.getActiveChild(props),
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.children !== this.props.children) {
      this.setState({
        activeChild: this.getActiveChild(nextProps),
      });
    }
  }

  getActiveChild(props) {
    return _.find(props.children, (child) => {
      return child.props.default;
    }) || props.children[0];
  }

  handleTabClick(child) {
    if (child.props.disabled) {
      return;
    }

    this.setState({
      activeChild: child,
    }, () => this.props.onChange(child));
  }

  render() {
    return (
      <div>
        <ul className="nav nav-tabs">
          {this.props.children.map((child, idx) => {
            let className = classNames(child.props.className, {
              'active': child == this.state.activeChild,
              'disabled': child.props.disabled,
            });

            return (
              <li key={idx} className={className}>
                <a href="javascript:void 0" onClick={() => this.handleTabClick(child)}>
                  {child.props.title}
                </a>
              </li>
            );
          })}
        </ul>
        <div className="tab-content">
          {this.state.activeChild}
        </div>
      </div>
    );
  }
}

export default Tabs;
